import { BeneficiaryRouteConfig } from '/@/modules/beneficiary/routes/BeneficiaryRouteConfig';
import { BeneficiaryRoutes } from '/@/modules/beneficiary/constants/BeneficiaryRoutes';

export const router = [
  BeneficiaryRouteConfig.factory({
    path: `/${BeneficiaryRoutes.INHERITANCE}/:beneficiaryId?`,
    name: BeneficiaryRoutes.INHERITANCE,
    component: () => import('/@/modules/beneficiary/pages/BeneficiarySpecificInheritancePage.vue'),
    props: (route) => ({
      beneficiaryId: !route.params?.beneficiaryId ? undefined : route.params?.beneficiaryId
    })
  }).build()
];
